import { Controller, useFormContext } from "react-hook-form";
import { FormHelperText, Box, FormControlLabel, Checkbox } from "@mui/material";

const CheckboxField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  return (
    <Box sx={{ mb: 3 }}>
      <Controller
        name={field.id}
        control={control}
        defaultValue={field.defaultChecked || false}
        rules={{
          required: field.required ? `${field.label} is required` : false,
        }}
        render={({ field: { onChange, value, ref } }) => (
          <>
            <FormControlLabel
              sx={{
                alignItems: "flex-start",
                "& .MuiFormControlLabel-label": {
                  paddingTop: 0,
                  textAlign: "justify",
                },
              }}
              control={
                <Checkbox
                  checked={!!value}
                  onChange={onChange}
                  inputRef={ref}
                  sx={{
                    paddingTop: 0,
                  }}
                />
              }
              label={field.label}
            />
            {errorMessage && (
              <FormHelperText error>{errorMessage}</FormHelperText>
            )}
          </>
        )}
      />
    </Box>
  );
};

export default CheckboxField;
